import { axios } from '@Root/API'

export const edit = (studyProgrammeId, courseInitiativeId, payload) => {
	return axios.post(`program/${studyProgrammeId}/course-initiative/${courseInitiativeId}`, payload)
}
